exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table .avatar[data-v-c02d2306]{width:40px;height:40px;border-radius:50%;vertical-align:middle;-o-object-fit:cover;object-fit:cover}table tbody td.username span.el-tag[data-v-c02d2306]{float:right}.pay[data-v-c02d2306]{padding:0 10px}.pay li[data-v-c02d2306]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.pay li *[data-v-c02d2306]:nth-child(2){font-weight:bold}.increase[data-v-c02d2306]{color:#0abb87}.decrease[data-v-c02d2306]{color:#c03639}", ""]);

// exports
